import React from "react";
import ReactDOM from "react-dom";
import assign from "lodash/assign";
import sample from "lodash/sample";
import * as lodashObject from "lodash/object";
import moment from "moment";
import addPlugin from "jquery-plugincreator";

import "jquery-mousewheel";

import general from "general";
import constants from "general/constants";
import resource from "general/resource";
import appointmentDAO from "general/dao/appointmentDAO";
import parseGETParameters from "general/functions/parseGETParameters";
import generateTimeSlotRequestData from "general/functions/generateTimeSlotRequestData";
import {
  getPatientGroup,
  getWorkplaceId,
} from "general/utils";
import { uriToId } from "general/utils";
import Survey from "survey/components/Survey";
import * as SurveyManager from "survey/manager";
import "general/components/calendar";

window.existingReservations = { reservationTimeout: null };

  let reservationTimeout = null,
  templates = {
    component: require("templates/booking/component.html"),
    calendar: require("templates/booking/calendar.html"),
    form: require("templates/booking/form.html"),
    result: require("templates/booking/result.html"),
    errors: {
      generic: require("templates/booking/errors/generic.html"),
      400: require("templates/booking/errors/400.html"),
      404: require("templates/booking/errors/404.html"),
      500: require("templates/booking/errors/500.html"),
      502: require("templates/booking/errors/502.html"),
    },
    vehicle: require("templates/booking/vehicle.html"),
  },
  defaults = {
    templates,
  },
  members = {
    /**
     * Plugin init function
     *
     * @returns {*}
     */
    init() {
      this.context.html(this.options.templates.component(this.options));
      this.spinner = document.querySelector(".booking-calendar__spinner");
      this.calendarElement = this.context
        .find(".booking-calendar__calendar")
        .html(this.options.templates.calendar(this.options));
      this.calendar = null;
      this.form = this.context.find(".booking-calendar__form");
      return this.setup();
    },
    /**
     * Asynchronous plugin setup function
     */
    setup: async function() {
      let spinner = this.spinner,
        calendarElement = this.calendarElement,
        form = this.form,
        self = this;

      /**
       * Displays the spinner container and starts the spinner
       */
      function spinnerOn(message) {
        if (message) {
          spinner.querySelector(".spinner_copy").innerHTML = message;
        }
        spinner.classList.remove(constants.hiddenClass);
      }

      /**
       * Disables the spinner and hides the spinner container
       */
      function spinnerOff() {
        spinner.classList.add(constants.hiddenClass);
      }

      /**
       * Function for onAfterViewLoad hook of calendar plugin
       *
       * @param {string} view
       */
      function onAfterViewLoad(view) {
        let appointmentRequestData = $("#appointment-request-data"),
          date = appointmentRequestData.data("timeslot-date"),
          time = appointmentRequestData.data("timeslot-time");

        // user has clicked on a timeslot
        this.context.find(".profile-cal__time-item").click(async (event) => {
          event.preventDefault();

          calendarElement.addClass(constants.hiddenClass);
          spinnerOn(self.spinner.dataset.reserveTimeslotCopy);

          const scrollToForm = function () {
            let bodyRect = document.body.getBoundingClientRect();
            let formRect = document.querySelector('.profile-content').getBoundingClientRect()
            let offset = formRect.top - bodyRect.top;
            offset = offset < 200 ? 0 : offset - 50;
            window.scrollTo({ top: offset, left: 0, behavior: 'smooth'});
          }

          const timeslotClicked = async function () {
            scrollToForm();

            import("components/form").then(function (_form) {
              let eventData = event.target.dataset;
              let practitionerId = eventData.eventPractitionerIds.split(",")[0];
              let vehicleQuantityElem = document.querySelector(
                "#vehicle_quantity_select");
              let rfvEl = document.querySelector("#reason_select");
              let rfvDs = rfvEl ? rfvEl.options[rfvEl.selectedIndex].dataset : {};

              general.registerUserActivity(
                "Timeslot",
                "Clicked",
                "Practitioner ID",
                parseInt(practitionerId),
              );

              _form.init({
                container: document.querySelector('.rm-container-form[form=rmcp_appointment]'),
                form_name: 'rmcp_appointment',
                data: {
                  pr: practitionerId,
                  wo: getWorkplaceId(),
                  pa: getPatientGroup(),
                  re: Number(rfvDs.id) || 0,
                  ra: Boolean(rfvDs.rate),
                  da: eventData.eventDate,
                  ti: eventData.eventTime,
                  du: eventData.eventDuration,
                  rs: eventData.eventReservationsAllowed == "true",
                  au: eventData.eventAutoAccept == "1",
                  ed: eventData.eventExternalDiary,
                  ve: vehicleQuantityElem?.value || 0,
                  pt: 1,
                  qs: encodeURIComponent(new URLSearchParams(window.location.search).toString())
                },
                hooks: {
                  after_show_form: function () {
                    spinnerOff();
                    form.removeClass(constants.hiddenClass);
                  },
                  error_show_form: function() {},
                  before_submit_form: function() {},
                  after_submit_form: function() {},
                  register_activity: function(dataset) {
                    return function(formData) {
                      return undefined;
                    }
                  }
                },
                callbacks: {
                  hide: function () {
                    form.addClass(constants.hiddenClass);
                    calendarElement.removeClass(constants.hiddenClass);
                    self.calendar.view();
                    scrollToForm();
                  },
                  errors: {
                    showErrorModal: function(message) {
                      general.modalMessage(message, "error");
                    },
                    reservation: {
                      expired: function() {
                        general.modalMessage(
                          "Unfortunately your session has expired. Please select a new time slot.",
                          "warning",
                          null,
                          "Session Expired",
                        );
                      }
                    }
                  },
                  registerUserActivity: function(activityType, activity, activityLabel, activityValue) {
                    general.registerUserActivity(activityType, activity, activityLabel, activityValue);
                  }
                }
              });
            });
          };

          if (SurveyManager.isPresent()) {
            await timeslotClicked();
          } else {
            const workplace = getWorkplaceId();
            const patientGroup = getPatientGroup();

            SurveyManager.get(workplace, patientGroup, "pre_appointment").then(
              async (survey) => {
                if (survey === null) {
                  return await timeslotClicked();
                }

                const calendarElem = document.querySelector(
                  ".booking-calendar__calendar"
                );
                const surveyElem = document.querySelector(
                  ".booking-calendar__survey"
                );

                ReactDOM.render(
                  <Survey
                    survey={survey}
                    callbacks={{
                      init: ({ reset = false } = {}) => {
                        spinnerOff();
                        surveyElem.classList.toggle(constants.hiddenClass);
                        if (reset) {
                          calendarElem.classList.toggle(constants.hiddenClass);
                          ReactDOM.unmountComponentAtNode(surveyElem);
                        }
                        general.attachSpinnerEvent(surveyElem);
                      },
                      onValidSurvey: async () => {
                        surveyElem.classList.toggle(constants.hiddenClass);
                        ReactDOM.unmountComponentAtNode(surveyElem);
                        spinnerOn(self.spinner.dataset.reserveTimeslotCopy);
                        return await timeslotClicked();
                      },
                    }}
                  />,
                  surveyElem
                );
              }
            );
          }
        });

        if (appointmentRequestData.length) {
          appointmentRequestData.remove();
          this.context
            .find(
              `.profile-cal__time-item[data-event-date="${date}"][data-event-time="${time}"]`
            )
            .click();
        }
      }

      try {
        spinnerOn(self.spinner.dataset.preloadCopy);
        let day = "now";
        let count = 0;
        let offset = 0;
        let prevOffset = 0;
        while (day == "now" && count < 5) {
          offset = Math.pow(2, count);
          let timeslotRequestData = generateTimeSlotRequestData(
            this.options.practitionerIds,
            this.options.workplaceId,
            moment().add(prevOffset, "week"),
            moment().add(prevOffset + offset, "week"),
            true
          );
          let res = resource("workplace")(this.options.workplaceId)(
            "dynamic_time_slot"
          );
          if (this.options.practitionerIds) {
            res = res("practitioners")(this.options.practitionerIds.join(","));
          }
          res = res("from")(timeslotRequestData.start_datetime);
          res = res("to")(timeslotRequestData.end_datetime);
          res = res("future-only")(timeslotRequestData.future_only);
          let response = await res.get({ limit: 1, expand: true });
          if (response && response.objects && response.objects.length >= 1) {
            day = response.objects[0].date;
          }
          count += 1;
          prevOffset = offset;
        }

        self.calendar = calendarElement
          .removeClass(constants.hiddenClass)
          .generalCalendar({
            day: day,
            workplaceId: this.options.workplaceId,
            practitionerIds: this.options.practitionerIds,
            onAfterViewLoad,
          });
      } catch (error) {
        if (error.name == "ResourceError") {
          this.context.html(
            this.options.templates.errors[error.error.status]({
              options: this.options,
              jqXHR: error.error,
            })
          );
        } else {
          this.context.html(
            this.options.templates.errors.generic({
              options: this.options,
              error: error,
            })
          );
        }
      } finally {
        spinnerOff();
      }
    },
  };

addPlugin("booking", defaults, members);